import {Component, Input, OnInit, AfterContentChecked} from '@angular/core';
import {DateFilterService} from '../../../../Services/dateFilter.service';

@Component({
  selector: 'app-as-of-date-select',
  templateUrl: './as-of-date-select.component.html',
  styleUrls: ['./as-of-date-select.component.css'],
  standalone: false
})
export class AsOfDateSelectComponent implements OnInit, AfterContentChecked {
  @Input() vm: any;
  @Input() showSpecificDates: boolean;

  constructor(public dateFilter: DateFilterService) {
  }

  ngOnInit() {
    if (this.vm) {
      // Keep monthCount visible for downstream consumers; it will be set by parent when computing fromDate
      if (this.vm.monthCount === undefined || this.vm.monthCount === null) {
        this.vm.monthCount = 0;
      }
    }
  }

  ngAfterContentChecked() {
    // When As-of (toDate) changes, parent components may recompute fromDate and monthCount.
    // Trigger no-op here to mirror original control refresh behavior for bindings.
    this.onDateValueChange();
  }

  onDateValueChange() {
    // Intentionally minimal: in As-of mode, monthCount is managed by parent using computed fromDate.
    // This hook exists to keep (change) handlers consistent with the original control.
  }
}
